export { default } from './Bullet'
